// Canonical list of active job roles. These are the ONLY roles that should be
// selectable when creating/editing entities (clients, jobs, applicants,
// candidates). Legacy roles (used historically but no longer in this list)
// stay available in filters and keep displaying on existing entities/profiles,
// but must not appear as new options in creation/edit forms.
export const ACTIVE_JOB_ROLES = [
	'C# .Net Developer',
	'C/C++ Developer',
	'Java Developer',
	'Javascript Developer',
	'Typescript Developer',
	'NodeJS Developer',
	'Mobile Developer',
	'iOS Developer',
	'Android Developer',
	'Python Developer',
	'Ruby Developer',
	'Go Developer',
	'PHP Developer',
	'Shopify Developer',
	'Rust Developer',
	'Software Architect',
	'Solutions Architect',
	'Front End Developer',
	'Full Stack Developer (NodeJS+React/Next/Angular)',
	'Full Stack Developer (.Net+React/Angular)',
	'Full Stack Developer (Java+React)',
	'Full Stack Developer (Python+React)',
	'Full Stack Developer (Go+React)',
	'AI Engineer',
	'GenAI Engineer',
	'AI RAG Engineer',
	'AI Data Engineer',
	'AI Security Engineer',
	'ML Ops Engineer',
	'AI Agentic Engineer',
	'Applied AI Engineer',
	'NLP Engineer',
	'LLM Engineer',
	'Computer Vision Engineer',
	'Machine Learning Engineer',
	'Manual Tester',
	'Game Tester',
	'QA Automation Engineer',
	'SDET',
	'Mobile QA Engineer',
	'Data Analyst',
	'Database Administrator (DBA)',
	'Data Engineer',
	'Data Scientist',
	'Database Engineer',
	'Incident Manager',
	'System Administrator',
	'Network Engineer',
	'DevOps Engineer',
	'Site Reliability Engineer (SRE)',
	'Technical Support Analyst',
	'Infrastructure Engineer',
	'IT Engineer',
	'Cloud Engineer',
	'Security Engineer',
	'Compliance Analyst',
	'Application Security Engineer',
	'DevSecOps Engineer',
	'SOC Analyst',
	'Penetration Tester',
	'IAM Engineer',
	'Risk Analyst',
	'Salesforce Developer',
	'Salesforce Administrator',
	'Salesforce App Engineer',
	'Salesforce Business Analyst',
	'SAP Developer',
	'SAP Business Analyst',
	'SAP QA',
	'SAP Administrator',
	'Workday Administrator',
	'Workday Tester',
	'Atlassian Administrator',
	'Project Manager',
	'Business Analyst',
	'Scrum Master',
	'Product Manager',
	'UX/UI Designer',
	'Product Owner',
	'Designer',
	'Product Designer',
	'Web Developer',
	'Media Specialist',
	'Web Content Specialist',
	'Consultant'
];

const normalize = name => (name || '').trim().toLowerCase();

const ACTIVE_JOB_ROLE_NAME_SET = new Set(ACTIVE_JOB_ROLES.map(normalize));

export const isActiveJobRole = name =>
	ACTIVE_JOB_ROLE_NAME_SET.has(normalize(name));

// Legacy roles still in use on existing records. Shown in filters alongside active
// roles, but not offered in create/edit form dropdowns.
export const LEGACY_JOB_ROLES = [
	'Back End Developer',
	'Database Administrator',
	'Ethical Hacker / Penetration Tester',
	'Full Stack Engineer',
	'Mobile Engineer',
	'Other',
	'Security Specialist',
	'Solutions Architect',
	'Technical Lead/Manager'
];

const LEGACY_JOB_ROLE_NAME_SET = new Set(LEGACY_JOB_ROLES.map(normalize));

export const isLegacyJobRole = name =>
	LEGACY_JOB_ROLE_NAME_SET.has(normalize(name));

export const isRetainedJobRole = name =>
	isActiveJobRole(name) || isLegacyJobRole(name);
